import { RootState } from '@app/redux/root-reducer';
export const selectDashboardState = (store: RootState) => store.dashboardReducer.dashboard;
export const selectDepartedUsersState = (store: RootState) => store.dashboardReducer.departedUsers;
export const selectGetFilteredInternsState = (store: RootState) =>
  store.dashboardReducer.getFilteredInterns;
export const selectGetFilteredCandidatesState = (store: RootState) =>
  store.dashboardReducer.getFilteredCandidates;
export const selectGetTasksOverviewState = (store: RootState) =>
  store.dashboardReducer.getTasksOverview;
export const selectGetTaskOverviewByIdState = (store: RootState) =>
  store.dashboardReducer.getTasksOverviewById;
export const selectGetMyProjectLeadersState = (store: RootState) =>
  store.dashboardReducer.getMyProjectLeaders;
export const selectGetProjectContribution = (store: RootState) =>
  store.dashboardReducer.getProjectContribution;
export const selectGetTaskAssignmentState = (store: RootState) =>
  store.dashboardReducer.getTaskAssignment;
export const selectGetRemainingTaskState = (store: RootState) =>
  store.dashboardReducer.getRemainingTasks;
